export default {
    login: {
        title: 'Inicia sesión en tu cuenta',
        subtitle: 'Ingresa tus credenciales para acceder al panel de administración',
        emailLabel: 'Email',
        emailPlaceholder: 'nombre@empresa.com',
        passwordLabel: 'Contraseña',
        passwordPlaceholder: '••••••••',
        forgotPassword: '¿Olvidaste tu contraseña?',
        submitButton: 'Iniciar sesión',
        noAccount: '¿No tienes una cuenta?',
        contactAdmin: 'Contactar administrador',
        credentialsTitle: 'Credenciales Demo',
        errorInvalidCredentials: 'Credenciales no válidas',
        errorLogin: 'Error durante el inicio de sesión',
    },
    resetPassword: {
        title: 'Restablecer contraseña',
        subtitle: 'Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña',
        emailLabel: 'Email',
        emailPlaceholder: 'nombre@empresa.com',
        submitButton: 'Enviar enlace de restablecimiento',
        backToLogin: 'Volver al inicio de sesión',
        successTitle: '¡Email enviado!',
        successMessage: 'Te enviamos un enlace para restablecer tu contraseña a',
        successInstructions: 'Revisa tu bandeja de entrada.',
        backToLoginButton: 'Volver al Inicio de Sesión',
        sendAnotherEmail: 'Enviar otro email',
        errorRequest: 'Error al solicitar restablecimiento de contraseña. Intenta de nuevo.',
        errorResend: 'Error al reenviar el email. Intenta de nuevo.',
        resendSuccess: '¡Email enviado exitosamente!',
    },
    newPassword: {
        title: 'Establecer Nueva Contraseña',
        subtitle: 'Ingresa tu nueva contraseña a continuación',
        verifying: 'Verificando token de restablecimiento...',
        noToken: 'Token de restablecimiento no proporcionado',
        invalidToken: 'Token de restablecimiento no válido o expirado',
        errorTitle: 'Token de Restablecimiento No Válido',
        backToLogin: 'Volver al Inicio de Sesión',
        passwordLabel: 'Nueva Contraseña',
        passwordPlaceholder: 'Ingresa nueva contraseña (mínimo 8 caracteres)',
        passwordConfirmLabel: 'Confirmar Nueva Contraseña',
        passwordConfirmPlaceholder: 'Reingresa la nueva contraseña',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        passwordsDoNotMatch: 'Las contraseñas no coinciden',
        submitButton: 'Restablecer Contraseña',
        resetError: 'Error al restablecer la contraseña. Intenta de nuevo.',
        successTitle: '¡Contraseña Restablecida!',
        successMessage: 'Tu contraseña ha sido restablecida exitosamente. Ahora puedes iniciar sesión con tu nueva contraseña.',
        redirecting: 'Redirigiendo al inicio de sesión...',
    },
    verifyInvitation: {
        title: 'Configura tu contraseña',
        titleExistingUser: 'Aceptar Invitación',
        subtitle: 'Has sido invitado a unirte a {{companyName}}. Configura tu contraseña para completar el registro.',
        email: 'Email: {{email}}',
        verifying: 'Verificando invitación...',
        noToken: 'Token de invitación no proporcionado',
        invalidToken: 'Token de invitación no válido o expirado',
        differentUser: 'Esta invitación es para otro usuario. Por favor, cierra sesión y usa la cuenta correcta.',
        errorTitle: 'Invitación no válida',
        goToLogin: 'Ir al Inicio de Sesión',
        goToHome: 'Ir al Inicio',
        passwordLabel: 'Contraseña',
        passwordPlaceholder: 'Ingresa contraseña (mínimo 8 caracteres)',
        passwordConfirmLabel: 'Confirmar Contraseña',
        passwordConfirmPlaceholder: 'Reingresa la contraseña',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        passwordsDoNotMatch: 'Las contraseñas no coinciden',
        submitButton: 'Configurar Contraseña',
        setupError: 'Error al configurar la contraseña',
        successTitle: '¡Contraseña configurada!',
        successMessage: 'Tu contraseña ha sido configurada exitosamente. Ahora puedes iniciar sesión.',
        redirecting: 'Redirigiendo al inicio de sesión...',
        existingUserMessage: 'Ya tienes una cuenta. Haz clic a continuación para aceptar la invitación y unirte a esta empresa.',
        acceptButton: 'Aceptar Invitación',
        acceptError: 'Error al aceptar la invitación',
    },
};

